import Vue from 'vue';

const defaultCrmFetch = (params) => {
  let {
    entity,
    idField,
    nameField,
    displayFields,
    returnFields,
    orderbyFields,
    customConditions,
    filterFields,
    pageSize,
    pageIndex,
    queryValue
  } = params;
  nameField = nameField || 'new_name';
  orderbyFields = orderbyFields || 'createdon asc';
  filterFields = filterFields || 'new_name';
  displayFields = displayFields || [
    {
      name: nameField,
      label: Vue.prototype.$tx('名称', 'lookup.column_name')
    },
    {
      name: 'createdon',
      label: Vue.prototype.$tx('创建时间', 'lookup.column_createdon'),
      width: 180
    }
  ];
  const getSelectString = () => {
    let selectFields;
    if (returnFields) {
      selectFields = returnFields.split(',');
    } else {
      selectFields = [];
    }

    selectFields.push(nameField);
    idField = idField || entity + 'id';
    selectFields.push(idField);

    // eslint-disable-next-line
    for (let i in displayFields) {
      let fieldName = displayFields[i].name;
      if (selectFields.indexOf(fieldName) >= 0) {
        continue;
      }
      selectFields.push(fieldName);
    }
    return selectFields.join(',');
  };
  let selectString = getSelectString();

  let url = `api/crmlookupview/data?entityName=${entity}&page=${pageIndex}&count=${pageSize}&select=${selectString}&orderby=${orderbyFields}&condition=${customConditions}&filter=${filterFields}&filterValue=${encodeURIComponent(
    queryValue || ''
  )}`;
  return rt.get(url);
};

export default {
  name: 'lookupPlugin',

  // 插件是否自动安装
  autoInstall: true,

  fetch: null,
  install () {
    Vue.prototype.$lookup = Vue.lookup = this;
  },
  resetFetch (fun) {
    this.fetch = fun;
  },
  getLookupData (params) {
    if (!this.fetch) throw new Error('you need register fetch function first!');
    let fetchMethod = this.fetch;
    return fetchMethod(params);
  },
  getCrmLookupData (params) {
    let fetchMethod = defaultCrmFetch;
    return fetchMethod(params);
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/lookup/index.js